module.exports = __webpack_public_path__ + "static/media/flow-monitor-online.ade53169.svg";